import React from 'react';
import { Post } from './PostType';
import Link from 'next/link';

const BlogCard: React.FC<{ post: Post }> = ({ post }) => {
    return (
        <Link href={`/blog/${post.id}`} className="transition-transform transform hover:scale-[1.03] max-w-sm rounded overflow-hidden shadow-lg m-4 bg-white2 hover:bg-gray-100 transition-colors duration-300 ease-in-out text-black2 hover:shadow-lg">
            <img className="w-full" src={post.imageUrl} alt={post.title} />
            <div className="p-6">
                <div className="flex flex-col gap-3">
                    <div className="flex gap-2 items-start text-sm text-gray-500 flex-col">
                        {post.category.map((category) => (
                            <span key={category} className="bg-gray-200 rounded-full px-3 py-1 font-semibold">{category}</span>
                        ))}
                    </div>
                    <h3 className="font-bold text-xl leading-tight">{post.title}</h3>
                    <div className="flex items-center text-sm">
                        <span className="text-gray-700">{post.author}</span>
                        <span className="text-gray-500 mx-2">•</span>
                        <time dateTime={post.date}>{post.date}</time>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default BlogCard;